import amapi from '@/api/amapi'

const initState = () => ({
  autoSslServiceId: '',
  runningAutoSsl: false,
  autoSslProblems: [],
  loadingAutoSslProblems: false,
  autoSslQueue: [],
  loadingAutoSslQueue: false,
  autoSslDisabledDomains: [],
  loadingAutoSslDisabledDomains: false,
})

const state = initState()

const getters = {
  autoSslServiceId: state => state.autoSslServiceId,
  runningAutoSsl: state => state.runningAutoSsl,
  autoSslProblems: state => state.autoSslProblems,
  loadingAutoSslProblems: state => state.loadingAutoSslProblems,
  autoSslQueue: state => state.autoSslQueue,
  loadingAutoSslQueue: state => state.loadingAutoSslQueue,
  autoSslDisabledDomains: state => state.autoSslDisabledDomains,
  loadingAutoSslDisabledDomains: state => state.loadingAutoSslDisabledDomains,
}

const mutations = {
  SET_AUTO_SSL_SERVICE_ID (state, id) {
    state.autoSslServiceId = id
  },
  SET_RUNNING_AUTO_SSL (state, running) {
    state.runningAutoSsl = running
  },
  SET_AUTO_SSL_PROBLEMS (state, problems) {
    state.autoSslProblems = problems
  },
  SET_LOADING_AUTO_SSL_PROBLEMS (state, loading) {
    state.loadingAutoSslProblems = loading
  },
  SET_AUTO_SSL_QUEUE (state, queue) {
    state.autoSslQueue = queue
  },
  SET_LOADING_AUTO_SSL_QUEUE (state, loading) {
    state.loadingAutoSslQueue = loading
  },
  SET_AUTO_SSL_DISABLED_DOMAINS (state, disabledDomains) {
    state.autoSslDisabledDomains = disabledDomains
  },
  SET_LOADING_AUTO_SSL_DISABLED_DOMAINS (state, loading) {
    state.loadingAutoSslDisabledDomains = loading
  }
}

const actions = {
  async getAutoSslProblems ({ commit, dispatch, getters }, { serviceId, username }) {
    if (getters.autoSslServiceId != serviceId) {
      commit('SET_AUTO_SSL_PROBLEMS', [])
    }
    commit('SET_LOADING_AUTO_SSL_PROBLEMS', true)
    const data = {
      id: serviceId,
      params: {
        uapi_module: 'SSL',
        uapi_function: 'get_autossl_problems'
      },
      username,
    }
    try {
      const response = await amapi.makecall('cpanel_uapi', data)
      if (Array.isArray(response.payload.data)) {
        commit('SET_AUTO_SSL_SERVICE_ID', serviceId)
        commit('SET_AUTO_SSL_PROBLEMS', response.payload.data)
      }
    } finally {
      commit('SET_LOADING_AUTO_SSL_PROBLEMS', false)
    }
  },
  async getAutoSslQueue ({ commit, getters }, serviceId) {
    if (getters.autoSslServiceId != serviceId) {
      commit('SET_AUTO_SSL_QUEUE', [])
    }
    commit('SET_LOADING_AUTO_SSL_QUEUE', true)
    const data = {
      id: serviceId,
      params: {
        uapi_module: 'SSL',
        uapi_function: 'get_autossl_pending_queue'
      }
    }
    try {
      const response = await amapi.makecall('cpanel_uapi', data)
      if (Array.isArray(response.payload.data)) {
        commit('SET_AUTO_SSL_SERVICE_ID', serviceId)
        commit('SET_AUTO_SSL_QUEUE', response.payload.data)
      }
    } finally {
      commit('SET_LOADING_AUTO_SSL_QUEUE', false)
    }
  },
  async getDisabledDomains ({ commit, getters }, { serviceId, username }) {
    if (getters.autoSslServiceId != serviceId) {
      commit('SET_AUTO_SSL_DISABLED_DOMAINS', [])
    }
    commit('SET_LOADING_AUTO_SSL_DISABLED_DOMAINS', true)
    const data = {
      id: serviceId,
      params: {
        uapi_module: 'SSL',
        uapi_function: 'get_autossl_excluded_domains'
      },
      username,
    }
    try {
      const response = await amapi.makecall('cpanel_uapi', data)
      if (Array.isArray(response.payload.data)) {
        commit('SET_AUTO_SSL_SERVICE_ID', serviceId)
        commit('SET_AUTO_SSL_DISABLED_DOMAINS', response.payload.data)
      }
    } finally {
      commit('SET_LOADING_AUTO_SSL_DISABLED_DOMAINS', false)
    }
  },
  clearAutoSsl ({ commit }) {
    commit('SET_AUTO_SSL_SERVICE_ID', '')
    commit('SET_RUNNING_AUTO_SSL', false)
    commit('SET_LOADING_AUTO_SSL_PROBLEMS', false)
    commit('SET_LOADING_AUTO_SSL_QUEUE', false)
    commit('SET_LOADING_AUTO_SSL_DISABLED_DOMAINS', false)
    commit('SET_AUTO_SSL_PROBLEMS', [])
    commit('SET_AUTO_SSL_QUEUE', [])
    commit('SET_AUTO_SSL_DISABLED_DOMAINS', [])
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
